/**
 * Created by ferasmasood on 8/14/17.
 */
window.GlobalSearchAPI = new function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    self.getGlobalSearchResult = function (timeStamp, brandId, searchPhrase, offset, limit, types) {
        var options = {
            limit: limit,
            offset: offset,
        };

        if (types) {
            options.types = types;
        }
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/search?search_phrase=" + encodeURIComponent(searchPhrase), "GET", options)
            .then(function (res) {
                    if (res.status === 200 && res.data && res.data.data) {
                        res.data.data.searchPhrase = searchPhrase;
                        res.data.data.offset = offset;
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };
};
GlobalSearchAPI.RECORDS_LIMIT = 30;
GlobalSearchAPI.RESULT_TYPE_APPLICANT = "APPLICANT";
GlobalSearchAPI.RESULT_TEAM_LIVE_EMPLOYEE = "TEAM_LIVE_EMPLOYEE";
GlobalSearchAPI.RESULT_ONBOARDING_EMPLOYEE = "ONBOARDING_EMPLOYEE";